/*
 * Module for the decision choice area, where decision choice labels can be assigned,
 * along with translations.  Holds a sortable list for multi-language support.  The module
 * let's you name the decision label for English (something to improve on later?), and then uses that label
 * to find a matching decision choice.  If one exists, it will load the foreign language labels for that
 * choice.  If not, it will create a new decision choice.  This means that decision choice labels are
 * shared (including their translations) across topics.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/topicLabelList/topicLabelListModule",
  "modules/topicsSplit/topic/topicDecisionArea/topicDecisionAreaView",
], function (Marionette, Messenger, TopicLabeListModule, TopicDecisionAreaView) {
  var TopicDecisionAreaController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicDecisionArea";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (conversationNode) {
      this.conversationNode = conversationNode;
      this.layout = new TopicDecisionAreaView.topicDecisionAreaLayout({
        model: this.conversationNode,
      });
      this.labels = this.addSubModule(
        new TopicLabeListModule({
          region: this.layout.decisionLabelList,
          hideHeader: true,
          hideEnglishLabel: true,
          namespace: this.name,
        }),
      );
      //way to get the controller context inside of the listenTo
      var _this = this;
      //handle decision intent when we change the english decision label (use listenTo to prevent duplicate event handlers building up on the model)
      this.layout.listenTo(
        conversationNode,
        "enter",
        function () {
          //find if there is an existing decision choice to use and apply it or create a new choice
          this.model.changeDecisionTopic();
          //reshow the labels module using the new decision
          _this._showSubViews(conversationNode);
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(conversationNode);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function (conversationNode) {
      if (conversationNode.decisionModel) {
        this.labels.show(conversationNode.decisionModel.topicLabels());
      }
    },
    _setUpVents: function () {
      //event when the a node from the conversation diagram is selected
      Messenger.vent.on(
        "selected:node",
        function (conversationNode) {
          this.show(conversationNode);
        },
        this,
      );
    },
  });

  return TopicDecisionAreaController;
});
